/* global bootstrap */

import React, { useContext, useEffect } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";

function OrderSummary({
  orderData,
  guestTotal,
  linkTotal,
  nicheTotal,
  linkInserts,
  nicheEdits,
  guestPosts,
}) {
  const { t } = useContext(LanguageContext);

  let tooltipInit = false;
  useEffect(() => {
    if (!tooltipInit) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tooltipInit = true;
    }
  }, []);

  return (
    <div className="col-12 confirm-cart-section px-xl-0">
      <div className="card text-white p-4 w-100">
        <div className="d-flex justify-content-between">
          <h4 className="card-title">{t("Order Summary")}</h4>
          <strong
            className="text-dark responsive-text-affiliation"
            style={{ fontWeight: "700" }}
          >
            {t("Total")}: ${orderData?.total}
          </strong>
        </div>
        <div
          className="mb-3 mt-2 border-bottom"
          style={{ margin: "0px -25px" }}
        ></div>
        <div className="d-flex flex-wrap flex-md-nowrap justify-content-between gap-5 d-xl-block w-100">
          <div
            className={`w-100 w-md-50 w-xl-100 d-sm-flex flex-wrap justify-content-between d-xl-block ${
              (!!orderData?.deductions?.credits?.length ||
                orderData?.deductions?.coupons?.length) &&
              (window.innerWidth >= 1200 || window.innerWidth <= 767)
                ? "border-bottom"
                : ""
            } `}
          >
            <div className="w-100">
              {!!guestPosts?.length && (
                <div className="d-flex justify-content-between mb-2 w-100">
                  <span
                    className="text-dark responsive-text-affiliation"
                    style={{ opacity: 0.8 }}
                  >
                    {guestPosts?.length}x {t("Guest Post(s)")}:
                  </span>
                  <span
                    className="text-dark responsive-text-affiliation"
                    style={{ fontWeight: "700" }}
                  >
                    ${guestTotal}
                  </span>
                </div>
              )}
              {!!linkInserts?.length && (
                <div className="d-flex justify-content-between mb-2">
                  <span
                    className="text-dark responsive-text-affiliation"
                    style={{ opacity: 0.8 }}
                  >
                    {linkInserts?.length}x {t("Link Insert(s)")}:
                  </span>
                  <span className="text-dark " style={{ fontWeight: "700" }}>
                    ${linkTotal}
                  </span>
                </div>
              )}
              {!!nicheEdits?.length && (
                <div className="d-flex justify-content-between mb-2">
                  <span
                    className="text-dark responsive-text-affiliation"
                    style={{ opacity: 0.8 }}
                  >
                    {nicheEdits?.length}x {t("Niche Edit(s)")}:
                  </span>
                  <span className="text-dark" style={{ fontWeight: "700" }}>
                    ${nicheTotal}
                  </span>
                </div>
              )}
              {!!orderData?.fees?.length &&
                orderData?.fees?.map((fees, i) => (
                  <div
                    key={i}
                    className={`d-flex justify-content-between ${
                      !!orderData?.deductions?.credits?.length ||
                      orderData?.deductions?.coupons?.length
                        ? "mb-2"
                        : ""
                    }`}
                  >
                    <span
                      className="text-dark responsive-text-affiliation"
                      style={{ opacity: 0.8 }}
                    >
                      {t("Processing Fee")}:{" "}
                      <i
                        className="bi-question-circle text-secondary ms-1"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={t("Processing Fee")}
                      />
                    </span>
                    <span
                      className="text-dark responsive-text-affiliation"
                      style={{ fontWeight: "700" }}
                    >
                      ${fees?.value}
                    </span>
                  </div>
                ))}
            </div>
          </div>
          {(orderData?.deductions?.credits?.length > 0 ||
            orderData?.deductions?.coupons?.length > 0) && (
            <div
              className="d-none d-md-block d-xl-none bg-soft-dark"
              style={{
                width: "0.0625rem",
                minHeight: "40px",
                maxHeight: "auto",
              }}
            ></div>
          )}
          <div className="w-100 w-md-50 w-xl-100">
            {orderData?.deductions?.credits?.length > 0 &&
              orderData?.deductions?.credits?.map((credit, index) => (
                <div
                  className="d-flex justify-content-between mt-xl-3 w-100"
                  key={index}
                >
                  <span
                    className="text-dark responsive-text-affiliation"
                    style={{ opacity: 0.8 }}
                  >
                    {t("Use Credits to Pay")}:{" "}
                  </span>
                  <strong
                    className="text-dark responsive-text-affiliation"
                    style={{ fontWeight: "700" }}
                  >
                    -${credit?.deduction}
                  </strong>
                </div>
              ))}
            {orderData?.deductions?.coupons?.length > 0 &&
              orderData?.deductions?.coupons?.map((coupons, index) => (
                <div
                  className="d-flex justify-content-between mt-2"
                  key={index}
                >
                  <span
                    className="text-dark responsive-text-affiliation"
                    style={{ opacity: 0.8 }}
                  >
                    {t("Promotion Code")} -{coupons?.value}%:
                  </span>
                  <strong
                    className="text-dark responsive-text-affiliation"
                    style={{ fontWeight: "700" }}
                  >
                    -${coupons?.deduction}
                  </strong>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderSummary;
